export enum EventAttendeeTypeEnum {
  Required = 'AttendeeType.Required',
  Optional = 'AttendeeType.Optional',
  Resource = 'AttendeeType.Resource',
}
